import { render, staticRenderFns } from "./exempt.vue?vue&type=template&id=50da96ca"
import script from "./exempt.vue?vue&type=script&lang=js"
export * from "./exempt.vue?vue&type=script&lang=js"
import style0 from "./exempt.vue?vue&type=style&index=0&id=50da96ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports